import { getReqs, setupCreateUpdateClocks } from 'features/firebase-app'
import * as firestore from 'firebase/firestore'
// This import loads the firebase namespace along with all its type information.
import {
  addDoc,
  deleteDoc,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore'
import ProcessedBranding from './processed-branding-model'
import {
  ProcessedBrandingMetaProperties,
  ProcessedBrandingProperties,
} from './processedBranding-property-definitions'

export async function load_processedBrandings($args: {
  uid: string
}): Promise<ProcessedBranding[]> {
  let { db } = getReqs()
  let { uid } = $args
  let collection = firestore.collection(
    db,
    `processedBrandings`,
    `${uid}`,
    'processedBranding',
  )
  let result: ProcessedBranding[] = []
  await firestore
    .getDocs(firestore.query(collection))
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ' => ', doc.data())
        result.push(convertToprocessedBranding(doc))
      })
    })
    .catch((error) => {
      console.log('Error getting documents: ', error)
    })
  return result.filter((x) => x)
}

function convertToprocessedBranding(doc: any) {
  let temp: any = {
    id: doc.id,
    ...doc.data(),
  }
  temp = {
    ...temp,
    fire_id: doc.id,
    id: doc.id,
  }
  setupCreateUpdateClocks(temp)

  return temp
}

export async function delete_processedBranding(args: {
  uid: string
  id: string
}): Promise<boolean> {
  let { db } = getReqs()
  if (args.uid) {
    let obj = firestore.doc(
      db,
      `processedBrandings`,
      `${args.uid}`,
      'processedBranding',
      args.id,
    )
    await deleteDoc(obj)
    return true
  }
  return false
}

export async function store_processedBranding(
  args: ProcessedBranding,
): Promise<ProcessedBranding> {
  let { db } = getReqs()
  let { owner, fire_id } = args
  if (fire_id) {
    // update
    let processedBranding_collection = firestore.doc(
      db,
      `processedBrandings`,
      `${owner}`,
      'processedBranding',
      fire_id,
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(ProcessedBrandingProperties),
      ...Object.values(ProcessedBrandingMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    await updateDoc(processedBranding_collection, {
      ...temp,
      updated: serverTimestamp(),
    })

    return temp
  } else {
    // add
    let collection = firestore.collection(
      db,
      `processedBrandings`,
      `${owner}`,
      'processedBranding',
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(ProcessedBrandingProperties),
      ...Object.values(ProcessedBrandingMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    const docRef = await addDoc(collection, {
      ...temp,
      created: serverTimestamp(),
    })

    console.log('Document written with ID: ', docRef.id)
    temp.id = docRef.id
    temp.fire_id = docRef.id
    return temp
  }
}
